import * as React from 'react';
import { observer } from 'mobx-react';
import { NotTranslated } from '@execonline-inc/translations';

import { T } from '../../Translations';

const CopyrightNotice: React.FC = () => {
  const currentYear: number = new Date().getFullYear();

  return (
    <>
      <NotTranslated text={`© ${currentYear} ExecOnline.`} /> <T kind="All rights reserved" />
    </>
  );
};

export default observer(CopyrightNotice);
